// extracted by mini-css-extract-plugin
export var readonly = "_j7-1";
export var star = "_j7-0";